<template>
  <div class="tool position-relative" :class="{ 'tool--loading': loading }">

    <loader :loading="loading" class="position-fixed"></loader>

    <div v-if="products" class="tool__products js-material-form material-form position-relative"
         :class="{ 'fade': loading }"
    >
      <section v-for="(product, productIndex) in products" class="tool__product pt-4 pt-md-5 pt-lg-6"
               :class="getBackgroundColor(product.color, product.color_hex)"
               :style="{ backgroundColor: product.color_hex}"
      >
        <div class="container">
          <div class="row pb-2">
            <div class="col-12 col-md-8 col-lg-6">
              <h2 class="tool__product-title" v-if="product.title && !product.label" v-html="product.title"></h2>
              <h2 class="tool__product-title" v-if="product.title && product.label"
                  v-html="product.title + ' <span>' + product.label + '</span>'"></h2>
              <p class="tool__product-description" v-if="product.description" v-html="product.description"></p>
            </div>
          </div>
          <div class="row">
            <div
              class="col-12 col-sm-8 col-lg-4 pb-4 pb-lg-0 material-select material-input is-focus position-relative order-0">
              <label v-if="product.labelProducts"
                     v-html="product.labelProducts"
                     class="animated position-absolute"
                     :class="{'d-none': !dataObject.isMobile }"
              ></label>
              <select v-if="product.options"
                      v-model="selectedOptions[productIndex]"
                      @change="updateAmount($event, productIndex)"
                      class="text-truncate form-control position-relative material bg-transparent border-left-0 border-top-0 border-right-0 border-light shadow-none rounded-0 py-2 pl-0 pr-4 w-100"
                      :class="{'d-none': !dataObject.isMobile }"
              >
                <option value="-1" :selected="selectedOptions[productIndex] === -1" v-html="mobileOptionLabel(product.labelProducts)"></option>
                <option v-for="(option, index) in product.options" :value="index"
                        :selected="selectedOptions[productIndex] === index" v-html="mobileOptionLabel(option.label)">
                </option>
              </select>

              <div class="tool__select position-relative"
                   v-if="!dataObject.isMobile"
                   :class="{
                      'tool__select--active': selectOpen.includes(productIndex),
                      'tool__select--inactive': !selectOpen.includes(productIndex),
                   }">

                <button v-on:click="toggleSelect"
                        class="font-weight-bold text-truncate form-control position-relative material bg-transparent border-left-0 border-top-0 border-right-0 border-light shadow-none rounded-0 py-2 pl-0 pr-4 w-100"
                        :value="productIndex"
                        v-html="optionLabel(productIndex, selectedOptions[productIndex])"></button>

                <div class="tool__select-wrapper position-relative position-sm-absolute w-100 shadow-sm">

                  <ul class="tool__select-items bg-white m-0 d-block">
                    <li v-if="-1 !== selectedOptions[productIndex]">
                      <input type="radio"
                             :id="'tool__select-input-' + productIndex + '--1'"
                             value="-1" v-model="selectedOptions[productIndex]"
                             :selected="selectedOptions[productIndex] === -1">
                      <label :for="'tool__select-input-' + productIndex + '--1'"
                             class="d-block w-100"
                             v-html="product.labelProducts"></label>
                    </li>
                    <li v-for="(option, index) in product.options"
                        :class="{'active': index === selectedOptions[productIndex]}">
                      <input type="radio"
                             :id="'tool__select-input-' + productIndex + '-' + index"
                             :value="index" v-model="selectedOptions[productIndex]"
                             :selected="selectedOptions[productIndex] === index"
                             v-on:click="toggleSelect"
                      >
                      <label class="d-block w-100"
                             :for="'tool__select-input-' + productIndex + '-' + index"
                             v-html="option.label"></label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-4 col-lg-2 pb-4 pb-lg-0 material-input order-1 tool__product-amount"
                 :class="{
                  'fadeInUp': selectedOptions[productIndex] >= 0 && !delayedLoading,
                  'fadeOutDown': selectedOptions[productIndex] < 0 || typeof selectedOptions[productIndex] === 'string' && !delayedLoading,
                  'is-focus': amount[productIndex],
                  'animated' : !delayedLoading
                }"
            >
              <label class="position-absolute" v-html="product.labelAmount"></label>
              <input
                class="text-truncate form-control position-relative material border-left-0 border-top-0 border-right-0 border-light shadow-none rounded-0 py-2 px-1 w-100"
                type="number"
                min="0"
                :max="product.maxAmount"
                pattern="\[0-9]{1,}"
                step="1"
                inputmode="numeric"
                v-model.number="amount[productIndex]"
                :disabled="selectedOptions[productIndex] < 0"
                @keyup="amount[productIndex] = (Math.max(Math.min(Math.round(amount[productIndex]), product.maxAmount), 0) > 0 ? Math.max(Math.min(Math.round(amount[productIndex]), product.maxAmount), 0) : '')"
              />
            </div>
            <ToolBadge
              :value="calculation(amount[productIndex], 'price', productIndex )"
              :valueReadable="calculation(amount[productIndex], 'price', productIndex, true )"
              classes="col-12 col-sm-6 col-lg-auto animated d-flex flex-row align-items-center text-nowrap justify-content-between justify-content-lg-start mb-4 mb-lg-0 order-3 order-md-2"
              inputClasses="bg-secondary text-white tool__badge--large"
              :label="dataObject.label.non_member + ':'"
            ></ToolBadge>
            <ToolBadge
              :value="calculation(amount[productIndex], 'price_member', productIndex )"
              :valueReadable="calculation(amount[productIndex], 'price_member', productIndex, true )"
              classes="col-12 col-sm-6 col-lg-auto animated d-flex flex-row align-items-center text-nowrap justify-content-between justify-content-lg-start mb-4 mb-lg-0 order-4 order-md-3"
              inputClasses="bg-white tool__badge--large"
              :label="dataObject.label.member + ':'"
            ></ToolBadge>

            <div class="tool__product-description-after col-10 col-md-8 col-lg-6 pt-lg-3 pb-4 order-2 order-md-3"
                 v-if="product.descriptionAfter" v-html="product.descriptionAfter">
            </div>
          </div>
        </div>
      </section>

      <section v-if="products.length > 1"
               class="tool__totals"
               :class="{'tool__totals--active': showTotals, 'position-fixed': isStickyTotals, 'position-absolute': !isStickyTotals }">
        <div :class="{
              'fadeInUp animated': checkAllowShowTotals,
              'fadeOutDown animated': !checkAllowShowTotals,
        }">
          <button class="tool__totals-button position-absolute btn shadow-none"
                  @click="showTotals = !showTotals">
            <i aria-label="Open/Close" class="icon-chevron-down d-block"></i>
          </button>
          <div class="tool__totals-wrapper bg-white text-center text-sm-left overflow-hidden">
            <h3 class="tool__totals-title text-center" v-html="dataObject.label.totalTitle"></h3>

            <ToolBadge
              :value="totalDifference"
              :valueReadable="euro(totalDifference)"
              inputClasses="bg-primary w-100 mt-3"
              classes="d-sm-none"
            ></ToolBadge>

            <table class="table animated table--custom mb-0"
                   v-if="!dataObject.isMobile"
                   :class="{'fadeInUp': showTotals,'fadeOutDown': !showTotals }">
              <thead>
              <tr class="d-none d-md-table-row">
                <th v-html="dataObject.label.tableProduct"></th>
                <th v-html="dataObject.label.tableNormal"></th>
                <th v-html="dataObject.label.tableMemberPrice"></th>
                <th v-html="dataObject.label.tableSaving"></th>
                <th v-html="dataObject.label.tableTotalSavings"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(product, productIndex) in products" v-if="amount[productIndex] > 0">
                <td class="text-truncate py-md-0"
                    v-html="product.title"></td>
                <td class="text-truncate py-md-0"
                    v-html="'<s>' + calculation(amount[productIndex], 'price', productIndex, true ) + '</s>'"></td>
                <td class="text-truncate py-md-0"
                    v-html="calculation(amount[productIndex], 'price_member', productIndex, true )"></td>
                <td class="text-truncate py-md-0"
                    v-html="euro(calculation(amount[productIndex], 'price', productIndex ) - calculation(amount[productIndex], 'price_member', productIndex ))"></td>
                <td class="text-truncate p-md-0"
                    v-if="productIndex === 0" :rowspan="products.length">
                  <ToolBadge
                    :value="totalDifference"
                    :valueReadable="euro(totalDifference)"
                    inputClasses="bg-primary"
                  ></ToolBadge>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="dataObject.totalsDescription"
                 v-html="dataObject.totalsDescription" class="tool__totals-description mt-4"></div>
          </div>
        </div>
      </section>
    </div>

    <ToolForm
      classes="tool--form"
      action="toolProduct"
      :loading="loading"
      :title="dataObject.label.formTitle"
      :description="dataObject.label.formDescription"
      :titleSubmitted="dataObject.label.formTitleSubmitted"
      :descriptionSubmitted="dataObject.label.formDescriptionSubmitted"
      :submitLabel="dataObject.label.formSubmit"
      :errorMessages="dataObject.label.formErrors"
      :inputLabels="dataObject.label.FormInputs"
      :extraData="extraFormData"
      :disabled="formDisabled"
      :isMobile="dataObject.isMobile"
    />
  </div>
</template>
<script>

import ToolBadge from './ToolBadge';
import ToolForm from './ToolForm';
import Loader from './Loader';

export default {
  name: 'toolproducts',
  props: {
    objects: {
      type: String,
      required: true
    },
    dataset: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      selectedOptions: [],
      amount: [],
      selectOpen: [],
      loading: true,
      delayedLoading: true,
      showTotals: false,
      isStickyTotals: false
    }
  },

  created () {
    window.addEventListener('scroll', this.isStickyTotalsScrollHandler);
    window.addEventListener('DOMContentLoaded', this.isStickyTotalsScrollHandler);
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.isStickyTotalsScrollHandler);
    window.removeEventListener('DOMContentLoaded', this.isStickyTotalsScrollHandler);
  },

  mounted() {
    this.setDefaultValues();

    let self = this;
    setTimeout(function () {
      // Make sure we don't see weird animation on load
      self.loading = false;
    }, 2000);

    setTimeout(function () {
      // Make sure we don't see weird animation on load
      self.delayedLoading = false;
    }, 1000);
  },

  computed: {
    // Set products from parsed Data
    products() {
      return JSON.parse(this.objects);
    },

    dataObject() {
      return JSON.parse(this.dataset);
    },

    checkAllowShowTotals() {
      let amount = 0;
      for (let i = 0, j = this.products.length; i < j; i++) {
        amount += this.amount[i];
      }
      return amount > 0;
    },

    /*
    * Set disabled
    */
    formDisabled() {
      return !this.checkAllowShowTotals;
    },

    /**
     * Extra form data for the Ajax Call
     */
    extraFormData() {

      let objects = [];
      this.totalDifference = 0;
      for (let i = 0, j = this.products.length; i < j; i++) {

        if (this.amount[i] > 0) {
          objects.push({
            amount: this.amount[i],
            product: this.products[i].title,
            price: this.calculation(this.amount[i], 'price', i, true),
            price_member: this.calculation(this.amount[i], 'price_member', i, true),
            discount: this.euro(this.calculation(this.amount[i], 'price', i) - this.calculation(this.amount[i], 'price_member', i))
          });

          this.totalDifference += this.calculation(this.amount[i], 'price', i) - this.calculation(this.amount[i], 'price_member', i);
        }
      }

      // Return empty if undefined or empty
      if (!objects || isNaN(this.totalDifference)) {
        return {};
      }

      // Return populated object
      return {
        totalDifference: this.euro(this.totalDifference),
        products: objects
      };
    }
  },

  methods: {

    /**
     * Scroll position for the stickt header.
     */
    isStickyTotalsScrollHandler(event) {
      // bottom position of last element minus the header height + scroll position + offset).
      this.isStickyTotals = this.sectionsEnd > (window.innerHeight + window.scrollY + 65);
    },


    /**
     * Set default onload values
     */
    setDefaultValues() {
      for (let i = 0, j = this.products.length; i < j; i++) {
        this.selectedOptions[i] = -1;
        this.amount[i] = '';
      }

      // Set bottom position of last section onto a variable.
      this.sectionsEnd = 0;
      const sections = document.getElementsByClassName('tool__product');
      if(sections) {
       this.sectionsEnd = sections[sections.length - 1].getBoundingClientRect().bottom;
      }
    },

    /**
     * Update Amount field, by resetting the value if current is -1
     */
    updateAmount(event, index) {
      if (event.target.value === '-1') {
        this.amount[index] = '';
      }
    },

    /**
     * quick totalLoop for computed functions
     */
    totalLoop(key) {
      let price = 0;
      for (let i = 0, j = this.products.length; i < j; i++) {

        if( undefined === this.amount[i]) {
          this.amount[i] = 0;
        }
        if( undefined === this.selectedOptions[i] && this.amount[i] < 1) {
          continue;
        }
        price += this.get(i, this.selectedOptions[i], key) * this.amount[i];
      }
      return price;
    },

    /**
     * Return prefixed background class based on string
     * @param colorString
     * @returns {string||null}
     */
    getBackgroundColor(colorString, hex = '') {
      if (colorString && !hex) {
        return 'bg-' + colorString;
      }

      // Return nothing
      return null;
    },

    /**
     * @param productIndex Index of the product
     * @param index Index of the selected option
     * @param type
     * @returns {*}
     */
    get(productIndex = '', index = '', type = 'price') {

      if (!productIndex || !index || productIndex === -1 || index === -1) {
        productIndex = 0;
        index = 0;
      }

      switch (type) {
        case 'price':
          return this.products[productIndex].options[index].price;
        case 'price_member':
          return this.products[productIndex].options[index].price_member;
        case 'price_optional':
          return this.products[productIndex].options[index].price_optional;
        case 'calculation':
          return this.products[productIndex].options[index].calculation;
        case 'calculation_optional':
          return this.products[productIndex].options[index].calculation_optional;
      }
    },

    calculation(amount = 0, type = '', productIndex = '', readable = false, calculation = '') {
      if (amount === 0 || type === ''
        || !amount || !type
        || amount === undefined || type === undefined
        || amount == null || type == null
        || productIndex == null || productIndex === undefined
      ) {
        return readable ? this.euro(0) : 0;
      }

      if( undefined === this.selectedOptions[productIndex] || this.selectedOptions[productIndex] < 0) {
        return readable ? this.euro(0) : 0;
      }

      // String to calc '1*3'
      const formula = this.stringToCalc(
        (typeof amount === 'number' || this.isNumeric(amount)
            ? amount
            : 0
        )
        + (
          calculation ? calculation : this.products[productIndex].options[this.selectedOptions[productIndex]].calculation
        )
        + (typeof type === 'number' || this.isNumeric(type)
          ? type
          : this.products[productIndex].options[this.selectedOptions[productIndex]][type]
        )
      );

      // Return formula for the user or code
      return readable ? this.euro(formula) : formula;
    },

    /**
     * Check for nummeric, sometimes parsed as string while is nummeric.
     */
    isNumeric(str) {
      if (typeof str === 'number') {
        return true;
      }

      if (typeof str !== "string") {
        return false;
      }

      return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    },

    /**
     * String to calculation '1*2' returns into 1*2
     */
    stringToCalc(fn) {
      return new Function('return ' + fn)();
    },

    /**
     * Return interget into readable Euro logic
     * @param int
     * @returns {string}
     */
    euro(int) {
      return new Number(int).toLocaleString("nl-NL", {
        style: "currency",
        currency: "EUR"
      });
    },

    /**
     * Return option label of fake select
     */
    optionLabel(productIndex, index) {
      if (index >= 0) {
        return this.products[productIndex].options[index].label;
      }
      return this.products[productIndex].labelProducts;
    },

    /**
     * Toggle fake select
     * @param event
     */
    toggleSelect: function (event) {
      if (event.target.nodeName === 'BUTTON') {
        const index = parseInt(event.target.value);

        if (this.selectOpen.includes(index)) {
          // Open specific
          this.selectOpen = this.selectOpen.filter(key => key !== index);
        } else {
          // Push index
          this.selectOpen.push(index);
        }
      } else {
        // Flush all
        this.selectOpen = [];
      }
    },

    /**
     * No HTML tags are supported in <option>
     * @param label
     */
    mobileOptionLabel(label) {
      return label.replace('<sup>', '&sup').replace('</sup>', ';');;
    }
  },
  components: {
    ToolBadge,
    ToolForm,
    Loader
  }
}

</script>
